'use client';

import { useQuery } from '@tanstack/react-query';
import { BSOL_STATS_API_RESPONSE, fetchBSolMetrics } from '@drift-labs/sdk';
import useIsMainnet from '../useIsMainnet';
import { getRetryDelayFn } from '../../utils/query/retryDelay';

export const useBSolFetch = () => {
	const isMainnet = useIsMainnet();

	return useQuery({
		queryKey: ['bsolMetrics'],
		queryFn: async (): Promise<BSOL_STATS_API_RESPONSE> => {
			const response = await fetchBSolMetrics();
			if (!response.ok) {
				throw new Error(`Failed to fetch bSOL metrics: ${response.status}`);
			}
			return response.json();
		},
		enabled: isMainnet,
		staleTime: 10 * 60 * 1000, // 10 minutes
		retryDelay: getRetryDelayFn(2000),
		retry: 3,
	});
};
